export type LaneResultsKind =
  | 'from_content'
  | 'from_catalog_entries'
  | 'hybrid';

export type SearchFeatureParams = {
  luna_max_results_per_offering: number;
  es_max_results_per_offering: number;
  luna_max_lane_cards: number;
  es_max_lane_cards: number;
  luna_hide_separator_within_group: boolean;
  es_hide_separator_within_group: boolean;
  luna_hide_separator_for_same_slug: boolean;
  es_hide_separator_for_same_slug: boolean;
  luna_omit_empty_preview_results: boolean;
  es_omit_empty_preview_results: boolean;
  luna_lane_results_kind: LaneResultsKind;
  es_lane_results_kind: LaneResultsKind;
  luna_open_offering_result_in_new_tab: boolean;
  es_open_offering_result_in_new_tab: boolean;
  ai_overview_max_lines: number;
};

export type SearchSourceConfig = {
  maxResultsPerOffering?: number;
  maxLaneCards: number;
  hideSeparatorWithinGroup: boolean;
  hideSeparatorForSameSlug: boolean;
  omitEmptyPreviewResults: boolean;
  laneResultsKind: LaneResultsKind;
  openOfferingResultInNewTab: boolean;
};

export type SearchFeatureParamsSource = 'luna' | 'es';

export const DEFAULT_SEARCH_FEATURE_PARAMS: SearchFeatureParams = {
  luna_max_results_per_offering: -1,
  es_max_results_per_offering: 3,
  luna_max_lane_cards: 12,
  es_max_lane_cards: 12,
  luna_hide_separator_within_group: true,
  es_hide_separator_within_group: true,
  luna_hide_separator_for_same_slug: true,
  es_hide_separator_for_same_slug: true,
  luna_omit_empty_preview_results: false,
  es_omit_empty_preview_results: false,
  luna_lane_results_kind: 'hybrid',
  es_lane_results_kind: 'from_content',
  luna_open_offering_result_in_new_tab: false,
  es_open_offering_result_in_new_tab: false,
  ai_overview_max_lines: 8,
};

export const mergeSearchFeatureParamsWithDefaults = (
  partial?: Partial<SearchFeatureParams>,
): SearchFeatureParams => ({
  ...DEFAULT_SEARCH_FEATURE_PARAMS,
  ...partial,
});

export const resolveSearchSourceConfig = (
  params: SearchFeatureParams,
  source: SearchFeatureParamsSource,
): SearchSourceConfig => {
  const maxResultsPerOffering =
    params[`${source}_max_results_per_offering` as const];

  return {
    maxResultsPerOffering:
      maxResultsPerOffering < 0 ? undefined : maxResultsPerOffering,
    maxLaneCards: params[`${source}_max_lane_cards` as const],
    hideSeparatorWithinGroup:
      params[`${source}_hide_separator_within_group` as const],
    hideSeparatorForSameSlug:
      params[`${source}_hide_separator_for_same_slug` as const],
    omitEmptyPreviewResults:
      params[`${source}_omit_empty_preview_results` as const],
    laneResultsKind: params[`${source}_lane_results_kind` as const],
    openOfferingResultInNewTab:
      params[`${source}_open_offering_result_in_new_tab` as const],
  };
};
